import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { AppConfigService, loadAppConfig } from './app/core/config/app-config.service';

loadAppConfig().then((config) => {
	if (config.production) {
		enableProdMode();
	}

	bootstrapApplication(AppComponent, createAppConfig()).catch((err) => console.error(err));
});

export function getApiUrl(): string {
	return new AppConfigService().config.apiUrl;
}

export function getProduction(): boolean {
	return new AppConfigService().config.production;
}

export function getDownloadFileUrl(): string {
	return new AppConfigService().config.downloadUrl;
}

export function getConfiguratorUrl(): string {
	return new AppConfigService().config.backendConfiguratorUrl;
}

export function getRegeneroUrl(): string {
	return new AppConfigService().config.regeneroBaseUrl;
}

export function getBackendAuthUrl(): string {
	return new AppConfigService().config.backendAuthUrl;
}

export function getFileManagerUrl(): string {
	return new AppConfigService().config.backendFileManagerUrl;
}
